import styled from 'styled-components';
import { H2, Text } from '@components/styles/Typography';
import useTranslation from '@hooks/useTranslation';
import { HeaderHorizontalMenu } from '@components/common';

const DefectiveSaleWarning = ({ listing, text }) => {
    const { t } = useTranslation();

    return (
        <Wrapper listing={listing}>
            {listing ? (
                <>
                    <LogoSizing />
                    <DefectiveWarningText listing={listing}>
                        <H2 fontSize="14px">{t('defectiveSale')}</H2>
                        <Text>{text}</Text>

                        <MenuAlignment>
                            <HeaderHorizontalMenu />
                        </MenuAlignment>
                    </DefectiveWarningText>
                    <MenuSizing />
                </>
            ) : (
                <DefectiveWarningText listing={listing}>
                    <H2 fontSize="14px">{t('defectiveSale')}</H2>
                    <Text>{text}</Text>
                </DefectiveWarningText>
            )}
        </Wrapper>
    );
};
const Wrapper = styled.div`
    padding: ${({ listing }) => (listing ? '0 45px' : '18px 0')};
    display: flex;
    justify-content: space-between;
    @media (max-width: 1024px) {
        padding: ${({ listing }) => (listing ? '9px 0' : '18px 0')};
        display: ${({ listing }) => (listing ? 'none' : 'flex')};
    }
    p {
        max-width: 380px;
    }
`;
const LogoSizing = styled.div`
    width: 100px;
`;
const MenuSizing = styled.div`
    width: 240px;
`;
const DefectiveWarningText = styled.div``;

const MenuAlignment = styled.div`
    opacity: 0;
    position: relative;
    z-index: -1;
    @media (max-width: 1024px) {
        display: none;
    }
`;
export default DefectiveSaleWarning;
